var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-input',{directives:[{name:"mask",rawName:"v-mask",value:('+998 (##) ### ## ##'),expression:"'+998 (##) ### ## ##'"}],key:"phone",attrs:{"type":"tel","placeholder":"+998 (__) ___ __ __"},model:{value:(_vm.model),callback:function ($$v) {_vm.model=$$v},expression:"model"}})
}
var staticRenderFns = []

export { render, staticRenderFns }